/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getAlumniProfile = /* GraphQL */ `
  query GetAlumniProfile($id: ID!) {
    getAlumniProfile(id: $id) {
      id
      firstName
      firstNameDisplay
      lastName
      lastNameDisplay
      about
      isOpenToWork
      isWillingToTravel
      publicProfile
      skills
      owner
      linkedInUrl
      countryCode
      stateCode
      cityName
      branch
      cohortID
      email
      isMilitarySpouse
      profilePictureKey
      createdAt
      updatedAt
    }
  }
`;
export const listAlumniProfiles = /* GraphQL */ `
  query ListAlumniProfiles(
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlumniProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCohort = /* GraphQL */ `
  query GetCohort($id: ID!) {
    getCohort(id: $id) {
      id
      name
      year
      alumni {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listCohorts = /* GraphQL */ `
  query ListCohorts(
    $filter: ModelCohortFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCohorts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        year
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const alumniProfilesByOwner = /* GraphQL */ `
  query AlumniProfilesByOwner(
    $owner: String
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alumniProfilesByOwner(
      owner: $owner
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const publicAlumniProfiles = /* GraphQL */ `
  query PublicAlumniProfiles(
    $publicProfile: SparseIndexTrue
    $firstName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    publicAlumniProfiles(
      publicProfile: $publicProfile
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const alumniProfilesByCohort = /* GraphQL */ `
  query AlumniProfilesByCohort(
    $cohortID: ID
    $firstName: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAlumniProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    alumniProfilesByCohort(
      cohortID: $cohortID
      firstName: $firstName
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        firstNameDisplay
        lastName
        lastNameDisplay
        about
        isOpenToWork
        isWillingToTravel
        publicProfile
        skills
        owner
        linkedInUrl
        countryCode
        stateCode
        cityName
        branch
        cohortID
        email
        isMilitarySpouse
        profilePictureKey
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
